import { useMemo } from 'react';
import { TrayInspectionStage } from 'api/models/Deliveries';
import { TrayInspectionInfo, TraySummary } from 'api/models/Trays';
import { Set } from 'api/models/Sets';
import { useDelivery } from './useDelivery';

// TODO: SS get set, tray and inspection where needed (SRP - not in here) => then replace this with useDelivery
const useFetchDelivery = (
  deliveryId: Parameters<typeof useDelivery>[0],
  setId?: string,
  trayId?: string,
  stage?: TrayInspectionStage,
) => {
  const { data: delivery, refetch } = useDelivery(deliveryId);

  const { set, tray, inspection } = useMemo<{
    set?: Set;
    tray?: TraySummary;
    inspection?: TrayInspectionInfo;
  }>(() => {
    const set = setId ? delivery?.sets.find(set => set.kitInstanceId == setId) : undefined;
    const tray = trayId ? set?.trays.find(tray => tray.trayInstanceId == trayId) : undefined;
    const inspection = stage ? tray?.inspections.find(i => i.stage == stage) : undefined;

    return { set, tray, inspection };
  }, [delivery?.sets, setId, stage, trayId]);

  return {
    delivery,
    set,
    tray,
    inspection,
    refetch,
  };
};

export default useFetchDelivery;
